module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-ExtraLight.f291df8d.ttf";